import React, { useState } from "react";
import Label from "../../FormComponents/Label";
import ButtonActionIcon from "../ButtonActionIcon";
import Input from "../../FormComponents/Input";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import RegexTester from "./RegexTester";

const RegexInput = ({ value = "", onChange, regex_custom_error, onCustomErrorChange }) => {
  const [regexError, setRegexError] = useState("");
  const [isTestingModalOpen, setIsTestingModalOpen] = useState(false);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    validateAndSave(newValue);
  };

  const validateAndSave = (newValue) => {
    try {
      new RegExp(newValue);
      setRegexError("");
    } catch {
      setRegexError("Invalid regex pattern");
    }

    onChange?.(newValue);
  };

  const saveCreatedRegex = (newValue) => {
    validateAndSave(newValue);
    setIsTestingModalOpen(false);
  };
  `z`;

  return (
    <div>
      <div>
        <div className={"d_flex align_center py_2 justify_between gap_2"}>
          <Label>Regex</Label>
          <ButtonActionIcon type={"science"} onClick={() => setIsTestingModalOpen(true)} />
        </div>

        <div className={"w_100"}>
          <Input
            id="regex-input"
            type="text"
            placeholder="Enter regex pattern"
            value={value}
            onChange={handleInputChange}
            style={{
              border: regexError ? "1px solid red" : "1px solid #ccc"
            }}
          />
          {regexError && <p style={{ color: "red", fontSize: "12px", marginTop: "0.25rem" }}>{regexError}</p>}
        </div>
      </div>
      <div>
        <div className={"d_flex align_center py_2 justify_between gap_2"}>
          <Label>Regex Error Message</Label>
        </div>

        <div className={"w_100"}>
          <Input
            id="regex_custom_error"
            type="text"
            name="regex_custom_error"
            placeholder="Enter Custom Error Message"
            value={regex_custom_error}
            onChange={(e) => onCustomErrorChange(e.target.value)}
          />
        </div>
      </div>

      <BuilderModal isOpen={isTestingModalOpen} onClose={() => setIsTestingModalOpen(false)} modalName={"Regex Tester"}>
        <RegexTester defaultValue={value} onSelect={saveCreatedRegex} />
      </BuilderModal>
    </div>
  );
};

export default RegexInput;
